<template>
	<admin-base-layout>
		<template slot="admin-page-header">
			<div class="flex-wrap-spacing">
				<h3 class="page-header">Users</h3>
			</div>
		</template>

		<template slot="admin-page-content">
			<loader v-if="!users"></loader>

			<div class="row" v-if="users && users.length == 0">
				<div class="col-xs-12">
					No users found.
				</div>
			</div>

			<div class="row" v-if="users && users.length > 0">
				<div class="col-xs-12 pad0">
					<div class="table-responsive">
						<table class="table table-hover tests_users_table">
							<thead>
								<tr>
									<th>Email</th>
									<th>Created</th>
									<th>API calls</th>
									<th>Expiration</th>
									<th>Data records</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="user in users" v-bind:key="user.email">
									<td class="tests_user_email">{{ user.email }}</td>
									<td>{{ [user.updatedAt] | moment("from", "now", true) }} ago</td>
									<td>{{ user.quota.quota }} </td>
									<td>{{ user.quota.ttl }}<!-- {{ [user.quota.ttl, 'seconds'] }} --></td>
									<td>{{ user.data_count }}</td>
									<td class="table-item-actions">
										<a @click="resetQuota(user.email)" class="tests_reset_quota_action" title="reset quota">
											<i class="fa fa-eraser"></i>
										</a>
										<a @click="deleteUser(user.email)" class="tests_delete_user_action" title="remove user">
											<i class="fa fa-times"></i>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</template>
	</admin-base-layout>
</template>

<script>
const logger = require("@/utils/logger");
const usersService = require("@/utils/users-api");
import router from "@/router";
import Vue from "vue";
const utils = require("@/utils/utils");

export default {
  data() {
    return {
      users: null
    };
  },
  methods: {
    getUsers() {
      usersService
        .list()
        .then(users => {
          this.users = users.sort(function(a,b) { return new Date(b.updatedAt) - new Date(a.updatedAt); });
        })
        .catch(utils.axiosErrorHandler);
    },
    deleteUser(email) {
      logger.log("Deleting user " + email);
      usersService
        .remove(email)
        .then(r => {
          for (var i in this.users) {
            if (this.users[i].email == email) {
              this.users.splice(i, 1);
              return;
            }
          }
        })
        .catch(utils.axiosErrorHandler);
    },
    resetQuota(email) {
      logger.log("Resetting quota for " + email);
      usersService
        .resetQuota(email)
        .then(r => {
          logger.log("Quota resetted successfully!");
          for (var i in this.users) {
            if (this.users[i].email == email) {
              this.users[i].quota = 0;
              return;
            }
          }
        })
        .catch(utils.axiosErrorHandler);
    }
  },
  mounted() {
    this.getUsers();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loader {
  margin-top: 10px;
  text-align: center;
}
.table-item-actions {
  text-align: right;
}

.users-actions {
  text-align: right;
  flex: 1;
}
.flex-wrap-spacing {
  margin-bottom: 10px;
}

.table-item-actions a {
  margin-left: 10px;
}
.table-item-actions a:hover {
  color: #000;
}
</style>
 


// WEBPACK FOOTER //
// src/components/superadmin/Users.vue